export enum OS {
  Android = 'Android',
  Linux = 'Linux',
  iOS = 'iOS',
  MacOS = 'Mac OS',
  Windows = 'Windows',
  ChromiumOS = 'Chromium OS',
}
